import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "pk_crm_token";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
    localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

export const crm = axios.create({ baseURL: API });
crm.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});
crm.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && !window.location.pathname.startsWith("/crm/login")) {
            clearToken();
            window.location.href = "/crm/login";
        }
        return Promise.reject(err);
    }
);

// Public (no auth) client for /pay/:token
export const pub = axios.create({ baseURL: API });

export const money = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
